import styled, { css } from 'styled-components'

export const Button = styled.div`
  display: inline-block;
  font-size: 0.65rem;
  font-family: ${(props) => props.theme.fonts.alt};
  border: 2px solid ${(props) => props.theme.colors.beige};
  padding: 0.25rem 0.5rem;
  text-transform: uppercase;
  margin-top: 1rem;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

export const Avatar = styled.div`
  width: 150px;
  height: 150px;
  background: no-repeat center center;
  background-size: cover;
  margin: 0 auto 1rem;
  border-radius: 50%;
`

export const Td = styled.div`
  font-size: 0.7rem;
  font-weight: 400;
  text-transform: uppercase;
  padding: 0.25rem;

  border-right: 1px dotted ${(props) => props.theme.colors.beige};

  &:last-child{
    border: 0;
  }

`

export const Row = styled.div`
  width: 100%;
  border-top: 1px dotted ${(props) => props.theme.colors.beige};
  box-sizing: border-box;
  display: flex;
`

export const Charge = styled.div`
  font-size: 1rem;
  font-weight: 300;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`

export const Name = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
`

export const Container = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.beige};
  box-sizing: border-box;
  padding: 1rem 1rem;
`

export const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid #333;
  border-radius: 5px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 10px);
  overflow: hidden;
`

const Wrapper = styled.div`
  background-color: #333333;
  box-shadow: 0 0 4px rgba(black, 0.1);
  border-radius: 10px;
  position: fixed;
  transform: translate(-20%, calc(-100% - 10px));
  pointer-events: none;
  
  ${(props) => props.special && css`
    transform: translate(-20%, 10%);
    ${Triangle}{
      bottom: auto;
      top: 0;
      transform: translate(-50%, -10px) rotate(180deg) ;
    }
  `}

`

export default Wrapper;